import React, { useState, useEffect } from 'react'
import { FaUndo, FaMoneyCheckAlt } from 'react-icons/fa'
import { FiSearch } from 'react-icons/fi'
import { IoExitOutline } from 'react-icons/io5'
import axios from 'axios'
import { API_HOST } from '../../api_utils'
import { toast } from 'react-toastify'
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function DefaultedLoan(props) {
  const { userDataFromStorage, coloredTheme } = props;
  const [loading, setLoading] = useState(false)
  const [userList, setUserList] = useState([])
  const [productList, setProductList] = useState([])
  const [customerList, setCustomerList] = useState([])
  const [customerHeaderList, setCustomerHeaderList] = useState([])
  const [loanHeaderList, setLoanHeaderList] = useState([])
  const [userCustomerLoan, setUserCustomerLoan] = useState([])

  // states for filter:
  const [filterData, setFilterData] = useState([])
  const [managerName, setManagerName] = useState('')
  const [agentName, setAgentName] = useState('')
  const [customerName, setCustomerName] = useState('')

  // get user's list:
  const getUsersList = async () => {
    setLoading(true)

    const config = {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${userDataFromStorage.token}`
      }
    }
    const { data } = await axios.get(`${API_HOST}/api/users/`, config);

    if (data) {
      if (data.message) {
        setLoading(false)
      } else {
        setLoading(false)
        setUserList(data)
      }
    } else {
      setLoading(false)
    }

  }

  const getLoanProductList = async () => {
    setLoading(true)
    const config = {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${userDataFromStorage.token}`
      }
    }
    const { data } = await axios.get(`${API_HOST}/api/loanproducts/get_loan_products`, config);
    if (data) {
      if (data.message) {
        setLoading(false)
      } else {
        setLoading(false)
        setProductList(data)
      }
    } else {
      setLoading(false)
    }
  }

  const getLoanHeaderList = async () => {
    setLoading(true)
    const config = {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${userDataFromStorage.token}`
      }
    }
    const { data } = await axios.get(`${API_HOST}/api/loan_header/`, config);
    if (data) {
      if (data.message) {
        setLoading(false)
      } else {
        setLoading(false)
        setLoanHeaderList(data)
      }
    } else {
      setLoading(false)
    }
  }

  const getCustomerList = async () => {
    setLoading(true)
    const config = {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${userDataFromStorage.token}`
      }
    }
    const { data } = await axios.get(`${API_HOST}/api/customer/get_all_customer`, config);
    if (data) {
      if (data.message) {
        setLoading(false)
      } else {
        setLoading(false)
        setCustomerList(data)
      }
    } else {
      setLoading(false)
    }
  }


  const getCustomerHeaderList = async () => {
    setLoading(true)
    const config = {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${userDataFromStorage.token}`
      }
    }
    const { data } = await axios.get(`${API_HOST}/api/customer_head/`, config);
    if (data) {
      if (data.message) {
        setLoading(false)
      } else {
        setLoading(false)
        setCustomerHeaderList(data)
      }
    } else {
      setLoading(false)
    }
  }

  useEffect(() => {
    getUsersList()
    getLoanProductList()
    getLoanHeaderList()
    getCustomerList()
    getCustomerHeaderList()
  }, [])

  useEffect(() => {
    if (userList.length && productList.length && loanHeaderList.length && customerList.length && customerHeaderList.length) {

      const userProductHeaderCustomerRef = loanHeaderList.map((x) => {
        let customerLoanList = customerList.find((y) => y._id === x.customer_ref);
        let customerHeaderCheck = customerHeaderList.find((l) => l._id === customerLoanList.customer_header)
        let loanProductCheck = productList.find((a) => a._id === x.loan_product_ref)
        if (customerLoanList && customerHeaderCheck) {
          let agentRef = userList.find((b) => b._id === customerLoanList.agent)
          if (agentRef) {
            let managerRef = userList.find((c) => c._id === agentRef.manager)
            let date = new Date(x.last_transaction_date)
            const formattedDate = new Intl.DateTimeFormat('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            }).format(date);

            let combinedStartOfDayData = {
              manager_name: managerRef.full_name,
              agent_name: agentRef.full_name,
              agent_id: agentRef._id,
              loan_header_id: x._id,
              customer_name: customerHeaderCheck.customer_name,
              product_code: loanProductCheck.product_code,
              loan_number: x.loan_number,
              last_transaction: formattedDate,
              cashOut: x.amount_dispersed,
              cashIn: x.amount_collected
            }

            return combinedStartOfDayData
          }
        }
      })

      if (userProductHeaderCustomerRef.length) {
        setUserCustomerLoan(userProductHeaderCustomerRef)
        setFilterData(userProductHeaderCustomerRef)
      }
    }
  }, [userList, productList, loanHeaderList, customerList, customerHeaderList])

  const filterCashHandler = () => {
    let filteredData1 = userCustomerLoan.filter((user) => {
      console.log('user', user)
      if (
        (!managerName || user.manager_name.includes(managerName)) &&
        (!agentName || user.agent_name.includes(agentName)) &&
        (!customerName || user.customer_name.includes(customerName))
        // (!agentRole || user.user_role === agentRole) &&
        // (!reportDateAfter || user.start_date > reportDateAfter) &&
        // (!reportDateBefore || user.start_date < reportDateBefore)
      ) {
        return true;
      }
      return false;

    })
    setFilterData(filteredData1)
  }


  return (
    <div className={userDataFromStorage.user_role === 'admin' ? 'xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden' : 'xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden'}>
      <p className='text-gray-800 text-[1.8rem] tracking-wider'>Defaulted Loans</p>
      <div className='bg-white  mt-[2%]'>
        <p style={{ backgroundColor: coloredTheme }} className=' text-white px-[0.5rem] py-[1rem] '>Search Parameters</p>

        <div className='px-[0.5rem] mt-2'>
          {/* <div className='md:flex xl:justify-start md:justify-between items-center mt-6 '>
            <p className='xl:w-[25rem]'>Default Period</p>
            <div className='flex md:items-center flex-col md:flex-row items-start justify-center '>
              <div className='mt-2 md:mt-0'>
                <input type={'radio'} id="thisMonth" />
                <label className='ml-1 mr-6' htmlFor='thisMonth'>This Month</label>
              </div>
              <div className='mt-2 md:mt-0'>
                <input type={'radio'} id="lastMonth" />
                <label className='ml-1 mr-6' htmlFor='lastMonth'>Last Month</label>
              </div>
              <div className='mt-2 md:mt-0'>
                <input type={'radio'} id="thisYear" />
                <label className='ml-1 mr-6' htmlFor='thisYear'>This Year</label>
              </div>
              <div className='mt-2 md:mt-0'>
                <input type={'radio'} id="LastYear" />
                <label className='ml-1 mr-6' htmlFor='LastYear'>Last Year</label>
              </div>
              <div className='mt-2 md:mt-0'>
                <input type={'radio'} id="All" />
                <label className='ml-1' htmlFor='All'>All</label>
              </div>
            </div>
          </div> */}
          <div className='md:flex justify-start items-center mt-6'>
            <p className='w-[25rem]'>Manager Last Name</p>
            <input value={managerName} onChange={(e)=>setManagerName(e.target.value)} type="text" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
          </div>
          <div className='md:flex justify-start items-center mt-6'>
            <p className='w-[25rem]'>Agent Last Name</p>
            <input value={agentName} onChange={(e)=>setAgentName(e.target.value)} type="text" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
          </div>
          <div className='md:flex justify-start items-center mt-6'>
            <p className='w-[25rem]'>Customer Name</p>
            <input value={customerName} onChange={(e)=>setCustomerName(e.target.value)} type="text" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
          </div>
        </div>

        <div className='flex justify-start items-center space-x-4 p-[1rem]'>
          <button onClick={()=>filterCashHandler()} style={{ backgroundColor: coloredTheme }} className='flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white'>
            <FiSearch />
            <p>Search</p>
          </button>
          <button style={{ backgroundColor: coloredTheme }} className='flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white'>
            <FaUndo />
            <p>Reset</p>
          </button>
        </div>
      </div>
      <div className='mt-8 overflow-scroll'>
        <p style={{ backgroundColor: coloredTheme }} className=' p-[1rem] lg:w-[100%] md:w-[130%] w-[220%] text-white'>Loan Details. Click on a loan to review/edit the Customer details/status.</p>
        <table className='lg:w-[100%] md:w-[130%] w-[220%]'>
          <thead className='h-[6vh]'>
            <tr className='border border-gray-700'>
              <th className='text-center  px-[0.2rem] border-b border-r   border-gray-700 '>Manager</th>
              <th className='text-center  px-[0.2rem] border-b border-r   border-gray-700 '>Agent</th>
              <th className='text-center  px-[0.2rem] border-b border-r   border-gray-700 '>Customer</th>
              <th className='text-center  px-[0.2rem] border-b border-r   border-gray-700 '>Loan Number</th>
              <th className='text-center  px-[0.2rem] border-b border-r   border-gray-700 '>Loan Product</th>
              <th className='text-center  px-[0.2rem] border-b border-r   border-gray-700 '>Cash Out</th>
              <th className='text-center  px-[0.2rem] border-b border-r   border-gray-700 '>Cash In</th>
              <th className='text-center  px-[0.2rem] border-b   border-gray-700 '>Last Collection Date</th>
            </tr>
          </thead>
          <tbody>
            {
              filterData.length ? filterData.map((x, index) =>
                <tr className={index % 2 === 0 ? 'bg-white border border-gray-700 ' : 'border border-gray-700 bg-sky-100'} key={index}>
                  <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>{x.manager_name}</td>
                  <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>{x.agent_name}</td>
                  <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>{x.customer_name}</td>
                  <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>{x.loan_number}</td>
                  <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>{x.product_code}</td>
                  <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>MYR {x.cashOut}</td>
                  <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>MYR {x.cashIn}</td>
                  <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>{x.last_transaction}</td>

                </tr>) : ''
            }
          </tbody>

        </table>
        <div className='mt-6 '>

          <button style={{ backgroundColor: coloredTheme }} className='flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white'>
            <IoExitOutline />
            <p>Exit</p>
          </button>
        </div>
      </div>

    </div>
  )
}

export default DefaultedLoan